import { render, staticRenderFns } from "./krSet.vue?vue&type=template&id=0bc834f4&scoped=true&"
import script from "./krSet.vue?vue&type=script&lang=js&"
export * from "./krSet.vue?vue&type=script&lang=js&"
import style0 from "./krSet.vue?vue&type=style&index=0&id=0bc834f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc834f4",
  null
  
)

export default component.exports